import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=0a744fb1&scoped=true&"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a744fb1",
  null
  
)

export default component.exports